// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const ApplePayIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'apple-pay'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M5.54675 7.5C5.16862 7.51945 4.70478 7.74186 4.43757 8.05422C4.19682 8.32161 3.98381 8.75915 4.03927 9.16995C4.4653 9.20642 4.89006 8.96455 5.15854 8.66192C5.41693 8.34835 5.59339 7.92782 5.54675 7.5ZM8.32853 8.01047V14.6866H9.40242V12.4053H10.8897C12.2485 12.4053 13.2026 11.5072 13.2026 10.203C13.2026 8.90257 12.2674 8.00925 10.9238 8.00925L8.32853 8.01047ZM9.40242 8.88433H10.6402C11.5716 8.88433 12.1035 9.36563 12.1035 10.2079C12.1035 11.049 11.5716 11.5351 10.6364 11.5351H9.40242V8.88433ZM5.42701 9.24895C4.85981 9.26111 4.38085 9.58926 4.10355 9.58926C3.80735 9.58926 3.35611 9.2684 2.86707 9.27691C2.54906 9.28505 2.23876 9.37308 1.96685 9.53232C1.69494 9.69155 1.47085 9.91646 1.31673 10.1848C0.65248 11.2884 1.14153 12.9255 1.78813 13.8249C2.10198 14.2698 2.48011 14.7596 2.97798 14.7413C3.44813 14.7243 3.63341 14.4472 4.20439 14.4472C4.77662 14.4472 4.943 14.7413 5.43961 14.7328C5.95639 14.7243 6.28032 14.288 6.59291 13.8419C6.9534 13.3351 7.10087 12.8453 7.10969 12.8198C7.10087 12.8101 6.11395 12.4454 6.10512 11.3504C6.09504 10.434 6.88029 9.99764 6.91684 9.9709C6.47317 9.33889 5.78245 9.2684 5.54297 9.25017L5.42701 9.24895ZM15.7676 9.73147C14.5198 9.73147 13.7434 10.3793 13.6854 11.258H14.6647C14.7555 10.8229 15.1298 10.5458 15.7298 10.5458C16.3625 10.5458 16.7419 10.8691 16.7419 11.4099V11.7855L15.3592 11.8633C14.1606 11.9289 13.4837 12.4515 13.4837 13.3023C13.4837 14.1774 14.1744 14.7693 15.1626 14.7693C15.8256 14.7693 16.4634 14.4278 16.7558 13.8857H16.7798V14.6866H17.773V11.3321C17.773 10.3562 16.9915 9.73147 15.7676 9.73147ZM18.2129 9.81897L20.0355 14.6915C20.0355 14.6951 19.9434 14.9832 19.9434 14.9917C19.7859 15.49 19.5275 15.6857 19.0473 15.6857C18.9603 15.6857 18.7876 15.6857 18.7107 15.6675V16.4769C18.7864 16.4903 19.0473 16.5 19.133 16.5C20.1791 16.5 20.6783 16.1208 21.1093 14.9406L23 9.81897H21.9059L20.6304 13.7799H20.6115L19.3347 9.81776L18.2129 9.81897ZM16.7419 12.4795V12.8635C16.7419 13.4968 16.1747 13.9781 15.4513 13.9781C14.8941 13.9781 14.5299 13.7009 14.5299 13.2743C14.5299 12.8587 14.8803 12.5937 15.4991 12.5536L16.7419 12.4795Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
ApplePayIcon.displayName = 'ApplePayIcon'
export { ApplePayIcon }
